import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {I18NextPipe} from "@kokos-i18next";

@Component({
  selector: 'kokos-forbidden-betriebe',
  imports: [I18NextPipe],
  templateUrl: './forbidden-betriebe.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenBetriebePage {
  readonly profilUrl = environment.profilUrl
}
